export default __webpack_public_path__ + "static/media/appPic1.8c94aa21.png";